import { HeartHandshake } from "lucide-react";

/** Split-panel shell for login/register. */
export default function AuthShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen flex">
      <div className="hidden lg:flex w-[42%] bg-teal-900 text-white flex-col justify-between p-12">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-xl bg-surface/10 flex items-center justify-center">
            <HeartHandshake className="h-6 w-6" />
          </div>
          <span className="text-lg font-semibold">NDIS Platform</span>
        </div>
        <div className="space-y-6 max-w-md">
          <h1 className="text-3xl font-semibold leading-snug">
            The operations platform for complex NDIS care.
          </h1>
          <ul className="space-y-3 text-teal-100/90 text-[15px]">
            <li className="flex gap-3"><span className="text-teal-300">—</span> Rosters, timesheets, and NDIS-correct invoicing in one flow</li>
            <li className="flex gap-3"><span className="text-teal-300">—</span> AI case notes grounded in your own care plans and shifts</li>
            <li className="flex gap-3"><span className="text-teal-300">—</span> Incident and complaint registers, audit-ready</li>
          </ul>
        </div>
        <p className="text-xs text-teal-200/60">Australian-hosted · NDIS Practice Standards aligned</p>
      </div>
      <div className="flex-1 flex items-center justify-center p-6 bg-page">
        {children}
      </div>
    </div>
  );
}
